<template>
  <div>
    <div class="field field-text">
      <label :for="name">{{$t(newLabel)}}</label>
      <div class="secret" v-show="state != 'field'">
        <input type="text" disabled :id="name" :placeholder="placeholder" class="field--input password-input">
        <a @click="stateSwitch" class="switch btn btn-tertiary btn-tiny btn-flat">
          Edit
        </a>
      </div>
      <div v-show="state == 'field'" class="real-field">
        <input v-model="newValue" ref="real-field" type="text" :id="name" :name="name" class="field--input text-input">
        <a @click="stateSwitch" class="switch icon yule-icon-close-small">
        </a>
      </div>
      <div v-if="error" class="field-error">
        {{error}}
      </div>
    </div>
  </div>
</template>
<script>
import Field from '@/components/helpers/DataInput/FormField'

export default {
  components: { Field },
  props: {
    label: String,
    classes: Array,
    name: String,
    value: {},
    required: {
      type: Boolean,
      default: false
    },
    collection: {},
    params: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Array,
      default: () => []
    },
    model: String,
    set_state: String
  },
  data () {
    return {
      newValue: '',
      error: null,
      state: 'secret'
    }
  },
  mounted () {
    if(this.set_state && this.set_state !== '') {
      this.state = this.set_state
    }
  },
  computed: {
    newLabel(){
      if(this.label){
        return this.label
      }else{
        return 'models.' + this.model + '.' + this.name
      }
    },
    placeholder(){
      return '●●●●●●●●●●●●●●●●●●●'
    }
  },
  methods: {
    stateSwitch(){
      this.newValue = ""
      if(this.state == 'secret'){
        this.state = "field"
        setTimeout(() => {
          this.$refs['real-field'].focus()
        }, 50);
      }else{
        this.state = "secret"
      }
    }
  },
  watch: {
    errors (errors){
      this.error = undefined
      this.errors.forEach((error) => {
        if(error.field_name == this.name){
          this.error = this.$t('errors.' + error.code)
        }
      })
    },
    newValue (val) {
      this.$emit('input', val)
    }
  }
}
</script>
<style lang="scss" scoped>
.field{
  .secret{
    input{
      user-select: none;
      pointer-events: none;
      opacity: 1;
      &::placeholder {
        color: #000;
        opacity: 1;
      }
    }
    position: relative;
  }
  .real-field{
    position: relative;
  }
  .switch{
    position: absolute;
    right: 0;
    top: 0px;
    z-index: 3;
    height: 39px;
  }
}
</style>



// WEBPACK FOOTER //
// SecretField.vue?5fd8b187